import DrawerCidade from './drawer';
import api from '../../services/api';
import { useEffect } from 'react';
import { useStateValue } from '../../state';
import { drawerActions, listagemActions, manutencaoActions } from '../../actions';
import { Col, Popover, Row, Tag, Select, Form } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { BreadcrumbIncluirDados, Editar, PesquisaOrdenacao, TabelaDados } from '../../components';
import { useState } from 'react';

export default function Cidade() {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [editando, setEditando] = useState(false);
    const [listaProvedor, setListaProvedor] = useState([]);
    const [listaVersao, setListaVersao] = useState([]);
    const [form] = Form.useForm();
    const [abaSelecionada, setAbaSelecionada] = useState("1");

    useEffect(() => dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: '+cid_descricao' } }), [listagemActions]);

    useEffect(() => {
        api.get(`Enum/Listar?nome=NFSeProvedor`).then(res => {
            if (res.status === 200) {
                setListaProvedor(res.data);
            }
        }).catch((erro) => console.error(erro));

        api.get(`Enum/Listar?nome=VersaoNFSe`).then(res => {
            if (res.status === 200) {
                setListaVersao(res.data);
            }
        }).catch((erro) => console.error(erro));

        // api.get(`Enum/Listar?nome=PercentualISSQN`).then(res => {
        //     if (res.status === 200) {
        //         setListaAliquota(res.data);
        //     }
        // }).catch((erro) => console.error(erro));

        // api.get(`Enum/Listar?nome=QtdServicoNFSe`).then(res => {
        //     if (res.status === 200) {
        //         setlistaItemQtdeNfse(res.data);
        //     }
        // }).catch((erro) => console.error(erro));
    }, []);

    function retornaDescricaoProvedor(cnf_provedornfse) {
        if (!!listaProvedor) {
            let provedor = listaProvedor.filter((pro) => (pro.key === cnf_provedornfse))[0];
            return !!provedor ? provedor.value : "";
        }
    };

    function retornaVersaoNfse(cnf_versaonfse) {
        if (!!listaVersao) {
            let versao = listaVersao.filter((pro) => (pro.key === cnf_versaonfse))[0];
            return !!versao ? versao.value : "";
        }
    };

    function editandoCidade(dados) {
        setEditando(true);
        dispatch({ type: manutencaoActions.CHANGE, data: { dados } });
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true } });
    }

    function filtrosAvancados(value) {
        let sql = ""

        sql += !!form.getFieldValue().provedor ? `&Provedor=${form.getFieldValue().provedor}` : "";
        sql += !!form.getFieldValue().versao ? `&VersaoSistema=${form.getFieldValue().versao}` : "";

        dispatch({ type: listagemActions.CHANGE, data: { filtro: `${!!value ? value : !!form.getFieldValue().filtroPor ? form.getFieldValue().filtroPor : ''}${sql}`, ordem: '+cid_descricao', pagina: 1 } });
    };

    return (
        <div className="p-10">
            <BreadcrumbIncluirDados />
            <Form layout="vertical" form={form}>
                <Row gutter={[8, 0]}>
                    {/* <Col xs={24} sm={17} md={17} lg={8} xl={8} xxl={9}>
                            <Form.Item label={"Pesquisar por"} name="filtroPor">
                                <Input.Search placeholder={"Código, descrição"} onSearch={valor => filtrosAvancados(valor)} allowClear />
                            </Form.Item>
                        </Col> */}
                    <Col xs={24} sm={24} md={14} lg={14} xl={14} xxl={14}>
                        <PesquisaOrdenacao opcoesOrdenacao={[
                            { label: "Nome A - Z", value: "+cid_descricao" },
                            { label: "Nome Z - A", value: "-cid_descricao" },
                        ]} />
                    </Col>
                    <Col xs={24} sm={24} md={5} lg={5} xl={5} xxl={5}>
                        <Form.Item label="Provedor NFS-e" name="provedor">
                            <Select
                                allowClear
                                onChange={() => filtrosAvancados()}
                                placeholder="Selecione um provedor"
                            >
                                {listaProvedor.map((provedor) => (
                                    <Select.Option key={provedor.key} value={provedor.key}>
                                        {provedor.value}
                                    </Select.Option>
                                ))}

                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={5} lg={5} xl={5} xxl={5}>
                        <Form.Item label="Versão NFS-e" name="versao">
                            <Select
                                allowClear
                                onChange={() => filtrosAvancados()}
                                placeholder="Selecione uma versão"
                            >
                                {listaVersao.map((provedor) => (
                                    <Select.Option key={provedor.key} value={provedor.key}>
                                        {provedor.value}
                                    </Select.Option>
                                ))}

                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <div className="tabela">
                <TabelaDados url="Cidade/ListarCidade"
                    colunas={[
                        {
                            title: 'Código',
                            width: 75,
                            align: 'center',
                            render: ({ cid_id, cid_status }) => (
                                <Popover content={cid_status ? 'Ativo' : 'Inativo'} placement="right">
                                    <Tag color={cid_status ? 'processing' : 'default'} className="w-100">
                                        <b>{cid_id}</b>
                                    </Tag>
                                </Popover>
                            ),
                        },
                        {
                            title: 'Cidades',
                            width: 400,
                            render: ({ cid_descricao }) => (
                                <div>
                                    <b>{cid_descricao}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Cód. IBGE',
                            width: 100,
                            align: 'center',
                            render: ({ cid_ibge }) => (
                                <div>
                                    <b>{cid_ibge}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Provedor de nfse',
                            width: 200,
                            render: ({ cidadeconfignfse }) => {
                                return (
                                    <div>
                                        <b>
                                            {retornaDescricaoProvedor(cidadeconfignfse?.cnf_provedornfse)}
                                        </b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Versão nfse',
                            width: 120,
                            align: 'center',
                            render: ({ cidadeconfignfse }) => {
                                return (
                                    <div>
                                        <b>{retornaVersaoNfse(cidadeconfignfse?.cnf_versaonfse)}</b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Aliquota ISSQN',
                            width: 100,
                            align: 'center',
                            render: ({ cidadeconfignfse }) => {
                               
                                return (
                                    <div>
                                        <b>{cidadeconfignfse?.cnf_percentualissqn ? cidadeconfignfse?.cnf_percentualissqn : "0"} %</b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Qtde Serviço',
                            width: 100,
                            align: 'center',
                            render: ({ cidadeconfignfse }) => {
                                return (
                                    <div>
                                        <b>
                                            {cidadeconfignfse?.cnf_qtdeserviconfse}
                                        </b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: 75,
                            fixed: 'right',
                            render: (dados) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Editar
                                                onClick={() => {
                                                    editandoCidade(dados);
                                                    setAbaSelecionada("1");
                                                }} icon={<EditOutlined />}
                                            />
                                        </Col>
                                        {/* <Col>
                                            <Excluir icon={<DeleteOutlined />} onClick={() => { modalExcluir(dados) }} />
                                        </Col> */}
                                    </Row>
                                </div>
                            ),
                        },
                    ]} />
            </div>
            <DrawerCidade cadCidade={true} editando={{ editando, setEditando }} />
        </div >
    );
}